import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
let CourseBox = class CourseBox extends Vue {
    constructor() {
        super(...arguments);
        this.showMask = false;
    }
    async clickBuy(link) {
        window.scrollTo(0, 0);
        await this.$emit('isLogined');
        let isLogin = await env.getIsLogin();
        if (!isLogin)
            return;
        this.showMask = env.type === 'ivydad';
        env.jump(link);
    }
    clickMask() {
        this.showMask = false;
        this.$emit('closeMask');
    }
};
tslib_1.__decorate([
    Prop()
], CourseBox.prototype, "courseList", void 0);
CourseBox = tslib_1.__decorate([
    Component
], CourseBox);
export default CourseBox;
